import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box, Alert, Button } from '@mui/material';
import QuizResults from '../../components/quiz/QuizResults';

const QuizResultsPage: React.FC = () => {
  const { quizId, attemptId } = useParams<{ 
    quizId: string; 
    attemptId: string; 
  }>();
  const navigate = useNavigate();
  
  const parsedQuizId = quizId ? parseInt(quizId) : null;
  const parsedAttemptId = attemptId ? parseInt(attemptId) : null;

  if (!parsedQuizId || isNaN(parsedQuizId) || !parsedAttemptId || isNaN(parsedAttemptId)) {
    return (
      <Container maxWidth="md">
        <Box py={4}>
          <Alert severity="error" sx={{ mb: 2 }}>
            Thông tin bài tập hoặc kết quả không hợp lệ
          </Alert>
          <Button
            variant="contained"
            onClick={() => navigate('/quizzes')}
          >
            Quay lại danh sách bài tập
          </Button>
        </Box>
      </Container>
    );
  }

  return <QuizResults quizId={parsedQuizId} attemptId={parsedAttemptId} />;
};

export default QuizResultsPage;
